export default class LoginErrors {
    constructor(){
        this.username = arguments[0];
        this.password = arguments[1];
    }
}